module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('Loader') : _c('div', [_c('div', {
    staticClass: "columns is-desktop"
  }, [_c('section', {
    staticClass: "column is-two-thirds is-offset-2"
  }, [_c('div', {
    staticClass: "flex-space-between"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("User Accounts")]), _vm._v(" "), _c('section', [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button",
      "name": "Add User",
      "value": "+ Add User"
    },
    on: {
      "click": function($event) {
        _vm.toggleShowAddUserModal()
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("School")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.users), function(u) {
    return _c('tr', [_c('td', {
      staticClass: "d-flex"
    }, [_c('img', {
      staticClass: "user-profile-image magic-button cursor-pointer",
      attrs: {
        "src": u.avatar_url
      }
    }), _vm._v(" "), _c('section', [_c('strong', [_vm._v(_vm._s(u.name))]), _c('br'), _vm._v(_vm._s(u.email) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(u.school) + "\n              ")]), _vm._v(" "), _c('td', [(u.is_coach) ? _c('span', {
      staticClass: "tag is-rounded is-primary"
    }, [_vm._v("Coach")]) : _vm._e(), _vm._v(" "), (u.is_group_admin) ? _c('span', {
      staticClass: "tag is-rounded is-warning"
    }, [_vm._v("Admin")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "flex-space-between"
    }, [(_vm.is_admin) ? _c('input', {
      staticClass: "button is-danger is-small",
      attrs: {
        "type": "button",
        "name": "Archive",
        "value": "Archive"
      },
      on: {
        "click": function($event) {
          _vm.archive_user(u.id, true)
        }
      }
    }) : _vm._e(), _vm._v(" "), (u.activated) ? _c('div', [_vm._v("Activated")]) : _c('div', [_vm._v("Needs Activating")])])]), _vm._v(" "), _c('td', [(!u.activated) ? _c('input', {
      staticClass: "button is-primary is-small is-outlined",
      attrs: {
        "type": "button",
        "name": "resend",
        "value": "resend email activation link"
      },
      on: {
        "click": function($event) {
          _vm.createInvite(u.email)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.invites), function(inv) {
    return (_vm.notUserYet(inv.email)) ? _c('tr', [_c('td', [_vm._v(_vm._s(inv.email))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Invited")]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "button is-info is-small is-outlined",
      attrs: {
        "type": "button",
        "name": "resend invite",
        "value": "resend invitation"
      },
      on: {
        "click": function($event) {
          _vm.resendInvite(inv.id, true)
        }
      }
    })])]) : _vm._e()
  })], 2)])])])]), _vm._v(" "), _c('AddUser', {
    attrs: {
      "title": "Add New User",
      "message": "What is their email address",
      "show": _vm.showAddUserModal
    },
    on: {
      "cancel": _vm.toggleShowAddUserModal
    }
  }), _vm._v(" "), (_vm.archived_users.length > 0) ? _c('section', {
    staticClass: "column is-two-thirds is-offset-2"
  }, [_c('div', {
    staticClass: "flex-space-between"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Archived Accounts")])]), _vm._v(" "), _c('section', _vm._l((_vm.archived_users), function(u) {
    return _c('div', {
      staticClass: "d-flex"
    }, [_c('img', {
      staticClass: "user-profile-image magic-button cursor-pointer",
      attrs: {
        "src": u.avatar_url
      }
    }), _vm._v(" "), _c('section', [_c('strong', [_vm._v(_vm._s(u.name))]), _c('br'), _vm._v(_vm._s(u.email) + "\n        ")]), _vm._v(" "), (_vm.is_admin) ? _c('input', {
      staticClass: "button is-primary is-small",
      attrs: {
        "type": "button",
        "name": "Re-activate",
        "value": "Re-activate"
      },
      on: {
        "click": function($event) {
          _vm.archive_user(u.id, false)
        }
      }
    }) : _vm._e()])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7a890717"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrgManage.vue
// module id = 1070
// module chunks = 0